import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  navLinks = [
  	{
  		label: 'Types de prestations' ,
  		path: 'prestations',
      canBeDeleted: false
  	},
  	{
  		label: 'Types d\'expertises',
  		path: 'expertises',
      canBeDeleted: false
  	},
  	{
  		label: 'Types de tarif',
  		path: 'tarifs',
      canBeDeleted: false
  	},
  ];
  constructor() { }

  ngOnInit() {
  }
  deleteTab(idx) {
    this.navLinks = this.navLinks.filter((value, index, arr) => index !== idx) ;
  }
}
